import { Injectable } from '@angular/core';
import { EXTERNAL_REFERENCE_SOURCE } from '../../app.constants';
import { BrapiSyncContextService } from '../../brapi-sync-context.service';

@Injectable({
    providedIn: 'root'
})
export class ExternalReferenceService {

    constructor(private context: BrapiSyncContextService) {
    }

    generateExternalReference(id: string, entity: EntityEnum, externalReferences?: any[]): any[] {
        const externalReferencesTemp: any[] = [];
        if (externalReferences && externalReferences.length) {
            externalReferences.forEach(er => {
                externalReferencesTemp.push(er);
            });
        }
        externalReferencesTemp.push({
            referenceID: this.getReferenceId(entity, id),
            referenceSource: EXTERNAL_REFERENCE_SOURCE
        });
        return externalReferencesTemp;
    }

    getReferenceId(entity: EntityEnum, id: string | undefined): string {
        if (id) {
            return `${this.context.source}/${entity}/${id}`;
        }
        return '';
    }
}

export enum EntityEnum {
  GERMPLASM = 'germplasm',
  STUDIES = 'studies',
  TRIALS = 'trials',
  OBSERVATIONUNITS = 'observationunits',
  OBSERVATION = 'observation'
}
